module.exports = "/assets/525c96944873de70ec28525e20f7b5d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MO.png
// module id = 1621
// module chunks = 0